import { Input } from "../../../design/input";
import { Button } from "../../../design/button";
import { Textarea } from "../../../design/textarea";
import { PaperClipIcon } from "@heroicons/react/20/solid";

interface IntakeDetailInputProps {
  inputRef: React.RefObject<HTMLTextAreaElement>;
  input: string;
  setInput: (input: string) => void;
  attachments: File[];
  setAttachments: (attachments: File[]) => void;
  sendMessage: () => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

const IntakeDetailInput: React.FC<IntakeDetailInputProps> = ({
  inputRef,
  input,
  setInput,
  attachments,
  setAttachments,
  sendMessage,
  handleKeyDown,
}) => {
  return (
    <div>
      <div className="flex items-center w-full mx-auto">
        <Textarea
          value={input}
          ref={inputRef}
          rows={4}
          onChange={(e) => setInput(e.target.value)}
          // onKeyDown={handleKeyDown}
          placeholder="Type your message..."
          className="flex-1 p-3 rounded-lg"
        />
        <Button
          onClick={sendMessage}
          className="px-4 py-2 ml-2 text-white bg-blue-600 rounded-lg"
        >
          Send
        </Button>
      </div>
      <div className="flex items-center gap-2 mt-2">
        <label htmlFor="file-upload" className="cursor-pointer">
          <PaperClipIcon className="w-5 h-5 text-gray-700 hover:text-blue-600" />
        </label>
        <input
          id="file-upload"
          type="file"
          onChange={(e) => setAttachments(Array.from(e.target.files || []))}
          accept="application/pdf"
          className="hidden"
        />
        {attachments.length > 0 && (
          <ul className="text-sm text-gray-600">
            {attachments.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default IntakeDetailInput;
